module.exports = __webpack_public_path__ + "static/media/tabby.9196ef38.svg";